const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;

export const MIRROR_AVATURN_CONFIG = {
  scaleOverride: isMobile ? 1.45 : 1.4,
  cameraDistanceOverride: isMobile ? 5.2 : 5.5,
  lookAtYOverride: (isMobile ? 1.45 : 1.05) as number | undefined,
  // Mobile users hold the phone below eye level; the avatar's forward gaze
  // lands on the forehead. Tilting the Spine bone ~4.6° forward cascades to
  // the head (Spine→…→Head in skeleton) so eye contact aligns with viewing
  // height. Iterate via this value only — no AvatarCore code change needed.
  modelTiltXRadians: isMobile ? 0.18 : 0,
  framing: 'full' as const,
  // Embedded model animation only; no automatic external fallback.
  animationUrl: undefined as string | undefined,
};

// MIRROR_METAPERSON_CONFIG — Aligned with MIRROR_AVATURN_CONFIG for visual
// parity. After commit cf8493c enabled embedded Male_Pose_Idle (A-pose) for
// MP M1, the bind pose difference vs Avaturn shrank — Iter 4 values
// (1.0 / 7.0 / 1.2) were calibrated for static T-pose and produced a
// smaller silhouette. Iter 5 adopts Avaturn dimensions with isMobile gate.
// Tilt remains 0 for now (Avaturn mobile uses +0.18 Spine tilt for forward
// gaze correction; defer matching tilt to MP until validated visually).
export const MIRROR_METAPERSON_CONFIG = {
  // Iter 6 (14/05): Iter 5 stretched MP (~65% taller than Avaturn at same
  // scaleOverride). MP path uses finalScale = (2.9/max(size))*scale vs
  // Avaturn path = (1.75/size.y)*scale → different base heights.
  // Derived for visual parity: scaleOverride = 2.45/2.9 ≈ 0.84
  // Safety margin: 0.85 desktop / 0.88 mobile.
  // Camera dist + lookAtY remain Avaturn-aligned.
  scaleOverride: (isMobile ? 0.88 : 0.85) as number | undefined,
  cameraDistanceOverride: (isMobile ? 5.2 : 5.5) as number | undefined,
  lookAtYOverride: (isMobile ? 1.45 : 1.05) as number | undefined,
  // Iter 7 (14/05): forward tilt mobile-only for eye contact parity with
  // Avaturn mobile. Avaturn uses 0.18 rad; MP gets 0.08 rad (subtler).
  // Desktop = 0 (camera angle already reto).
  modelTiltXRadians: isMobile ? 0.08 : 0,
  framing: 'full' as const,
  // MetaPerson uses its own embedded idle animation (V2-stripped to bind pose
  // at d8420ff + 7b8e9dd). External FBX is Avaturn-Mixamo retarget — applying
  // it on MP skeleton produces wrong head/spine/arm rotations ("Mixamo cloak"
  // over MetaPerson bind pose). MP must NOT load external animation.
  animationUrl: undefined as string | undefined,
};
